import React, { useCallback, useEffect, useRef, useMemo, useState } from "react"
import styles from "./PeriodSlider.module.scss"
import Picker from "react-month-picker"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { MakeMonthName, convertToMoment, MonthNames, BuildYears } from "modules/common/models/period"

export const PeriodSlider: React.FC<PeriodSliderProps> = (props) => {
    const { month, year, onChange } = props

    const pickerRef = useRef<any>(undefined)
    // Ручной контроль видимости окна — теперь оно никогда не закроется само при смене года
    const [isOpen, setIsOpen] = useState(false)

    const gotoNextMonth = useCallback(() => {
        const next = convertToMoment(month, year).add(1, "month")
        onChange(next.year(), next.month() + 1)
    }, [month, year, onChange])

    const gotoPreviousMonth = useCallback(() => {
        const prev = convertToMoment(month, year).subtract(1, "month")
        if (prev.isValid()) {
            onChange(prev.year(), prev.month() + 1)
        }
    }, [month, year, onChange])

    const onMonthChange = useCallback(
        (y: number, m: number) => {
            onChange(y, m)
            setIsOpen(false)

        },
        [onChange]
    )

    const togglePicker = useCallback((e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setIsOpen((prev) => !prev)
    }, [])

    // react-month-picker 2 открывает окно только методом show(): пропа show, как в первой
    // версии, больше нет. Щелчок мимо окна закрывает его — isOpen должен это знать,
    // иначе следующий щелчок по заголовку только «закрыл» бы уже закрытое окно
    useEffect(() => {
        isOpen && pickerRef.current && pickerRef.current.show()
    }, [isOpen])

    const onDismiss = useCallback(() => setIsOpen(false), [])

    const yearsOptions = useMemo(() => {
        try {
            return BuildYears(year) || [year]
        } catch {
            return [year]
        }
    }, [year])

    const monthName = useMemo(() => MakeMonthName(month), [month])

    return (
        <div className={`period-slider ${styles.slider}`} onClick={(e) => e.stopPropagation()}>
            <PlanrButton type="neutral" icon="general-big-arrow-left" onClick={gotoPreviousMonth} size="small" />

            <div className={styles.monthName} onClick={togglePicker}>
                <span className={styles.value} >
                    &nbsp;{monthName}&nbsp;
                </span>
                <div className={styles.year}>{year}</div>

                {isOpen && (
                    // щелчки внутри окна (стрелки года, месяцы) не всплывают до заголовка: он по
                    // щелчку открывает и закрывает окно, и стрелка года закрывала его, а выбор
                    // месяца открывал заново
                    <span style={{ display: "contents" }} onClick={(e) => e.stopPropagation()}>
                        <Picker
                            ref={pickerRef}
                            years={yearsOptions}
                            value={{ month, year }}
                            lang={MonthNames}
                            onChange={onMonthChange}
                            onDismiss={onDismiss}
                        />
                    </span>
                )}
            </div>

            <PlanrButton type="neutral" icon="general-big-arrow-right" onClick={gotoNextMonth} size="small" />
        </div>
    )
}

interface PeriodSliderProps {
    month: number
    year: number
    onChange: (year: number, month: number) => void
}
